/** Adapter between the API wallet (raw Prisma + client.name) and the UI `Wallet`.
 *  The wallet row has no per-wallet exchange rate (that lives on transactions),
 *  so `rate` defaults to DEFAULT_EXCHANGE_RATE for display. */

import { DEFAULT_EXCHANGE_RATE } from "@/lib/constants";
import type { Wallet } from "@/types";

export interface ApiWallet {
  id: string;
  clientId: string;
  balanceUsd: number | string;
  totalFundedDzd: number | string;
  totalSpentUsd: number | string;
  lowBalanceThresholdUsd?: number | string | null;
  client?: { name?: string | null } | null;
}

function toNumber(value: number | string | null | undefined): number {
  if (value === null || value === undefined) return 0;
  const n = typeof value === "string" ? Number(value) : value;
  return Number.isFinite(n) ? n : 0;
}

export function toWallet(api: ApiWallet): Wallet {
  return {
    id: api.id,
    clientId: api.clientId,
    clientName: api.client?.name ?? api.clientId,
    balanceUsd: toNumber(api.balanceUsd),
    spentUsd: toNumber(api.totalSpentUsd),
    fundedDzd: toNumber(api.totalFundedDzd),
    rate: DEFAULT_EXCHANGE_RATE,
  };
}
